<div class="subscription-settings-container">
    <div class="settings-header">
        <h2>SUBSCRIPTION SETTINGS</h2>
        <p class="hint">
            Manage your monthly subscription and purchase AI tokens. Download invoices and monitor your token usage.
            Ensure you always have the resources you need to enhance your workflow and free up your time.
        </p>
    </div>


    <mat-accordion multi="false">

        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    SUBSCRIPTION <mat-icon (click)="openOnboardingDialog()"
                        matTooltip="View onboarding steps">info_outline</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <h5 *ngIf="!isNewSubscription">SUBSCRIPTION</h5>
            <div class="totals-container" *ngIf="!isNewSubscription">
                <div class="total-block subscription-status-block"
                    [class.status-active]="subscriptionStatus === 'ACTIVE'">
                    <h3>Subscription Status</h3>
                    <p class="total" [class.status-active-text]="subscriptionStatus === 'ACTIVE'">{{subscriptionStatus}}
                    </p>
                    <p class="hint text-center" *ngIf="expiringMessage">{{expiringMessage}}</p>
                    <p class="hint text-center" *ngIf="subscriptionStatus === 'ACTIVE'">
                        <strong>Current Tier: {{isPremium ? 'Premium' : 'Standard'}}</strong>
                    </p>
                    <p class="hint text-center" *ngIf="subscriptionStatus === 'ACTIVE' && cardOnFileLabel">
                        {{ cardOnFileLabel }}
                    </p>
                    <button mat-raised-button (click)="purchaseSubscription()" *ngIf="subscriptionStatus !== 'ACTIVE'"
                        class="alt-button">Subscribe</button>
                    <div *ngIf="subscriptionStatus === 'ACTIVE'" class="subscription-actions">
                        <button mat-button (click)="openManageSubscriptionDialog()">Manage Subscription</button>
                        <button mat-raised-button color="primary" (click)="upgradeDowngradeSubscription('premium')"
                            *ngIf="!isPremium" class="m-t-10">Upgrade to Premium</button>
                        <button mat-button color="warn" (click)="upgradeDowngradeSubscription('standard')"
                            *ngIf="isPremium" class="m-t-10">Downgrade to Standard</button>
                    </div>
                </div>

            </div>

            <h5 *ngIf="!isNewSubscription">AI TOKENS</h5>
            <div class="totals-container" *ngIf="!isNewSubscription">

                <div class="total-block token-balance-block">
                    <h3>Token Balance</h3>
                    <p class="total" *ngIf="!isPremium">R{{tokenBalance}}</p>
                    <p class="total" *ngIf="isPremium">Unlimited</p>
                    <button mat-button (click)="openTokenPurchaseDialog()"
                        *ngIf="subscriptionStatus === 'ACTIVE' && !isPremium">Purchase Tokens</button>
                </div>
                <div class="total-block token-recharge-block" *ngIf="!isPremium"
                    [class.status-disabled]="autoRechargeStatus === 'DISABLED'"
                    [class.status-enabled]="autoRechargeStatus === 'ENABLED'">
                    <h3>Token Auto Recharge</h3>
                    <p class="total" [class.status-disabled-text]="autoRechargeStatus === 'DISABLED'"
                        [class.status-enabled-text]="autoRechargeStatus === 'ENABLED'">{{autoRechargeStatus}}</p>
                    <button mat-button (click)="openAutoRechargeDialog()"
                        *ngIf="subscriptionStatus === 'ACTIVE'">Configure Recharge</button>
                </div>

            </div>

            <h5 *ngIf="!isNewSubscription && !stateUnit">TEXT MESSAGE CREDITS</h5>
            <div class="totals-container" *ngIf="!isNewSubscription && !stateUnit">

                <div class="total-block message-credit-balance-block">
                    <h3>Message Credit Balance</h3>
                    <p class="total" *ngIf="!isPremium">{{textMessageCreditBalance}} credits</p>
                    <p class="total" *ngIf="isPremium">Unlimited</p>
                    <button mat-button (click)="openTextMessageCreditPurchaseDialog()"
                        *ngIf="subscriptionStatus === 'ACTIVE' && !isPremium">Purchase Credits</button>
                </div>
                <div class="total-block message-recharge-block" *ngIf="!isPremium"
                    [class.status-disabled]="textMessageAutoRechargeStatus === 'DISABLED'"
                    [class.status-enabled]="textMessageAutoRechargeStatus === 'ENABLED'">
                    <h3>Credit Auto Recharge</h3>
                    <p class="total" [class.status-disabled-text]="textMessageAutoRechargeStatus === 'DISABLED'"
                        [class.status-enabled-text]="textMessageAutoRechargeStatus === 'ENABLED'">
                        {{textMessageAutoRechargeStatus}}</p>
                    <button mat-button (click)="openTextMessageAutoRechargeDialog()"
                        *ngIf="subscriptionStatus === 'ACTIVE'">Configure Recharge</button>
                </div>
            </div>

            <ng-container *ngIf="isNewSubscription">

                <div class="totals-container">
                    <div class="total-block new-subscription" [class.selected]="selectedSubscriptionTier === 'standard'"
                        (click)="selectedSubscriptionTier = 'standard'">
                        <h3>Standard</h3>
                        <p class="total">ZAR 3,000.00</p>
                        <p class="vat-note">(excl. VAT)</p>
                        <p class="hint vat-hint">VAT (15%) will be added at checkout</p>
                        <p class="hint">Includes ZAR 200 AI tokens + 20 SMS credits monthly</p>
                        <p class="hint">Pay-as-you-go for additional usage</p>
                        <button mat-raised-button color="primary"
                            (click)="selectedSubscriptionTier = 'standard'; purchaseSubscription(); $event.stopPropagation()"
                            [class.selected]="selectedSubscriptionTier === 'standard'">Select Standard</button>
                    </div>
                    <div class="total-block new-subscription" [class.selected]="selectedSubscriptionTier === 'premium'"
                        (click)="selectedSubscriptionTier = 'premium'">
                        <h3>Premium</h3>
                        <p class="total">ZAR 6,000.00</p>
                        <p class="vat-note">(excl. VAT)</p>
                        <p class="hint vat-hint">VAT (15%) will be added at checkout</p>
                        <p class="hint"><strong>Unlimited AI tokens</strong></p>
                        <p class="hint"><strong>Unlimited SMS credits</strong></p>
                        <button mat-raised-button color="primary"
                            (click)="selectedSubscriptionTier = 'premium'; purchaseSubscription(); $event.stopPropagation()"
                            [class.selected]="selectedSubscriptionTier === 'premium'">Select Premium</button>
                    </div>
                </div>

                <div class="hint">
                    <strong>NOTE:</strong> The MedicAI subscription is a monthly plan that provides you with a
                    comprehensive AI
                    integrated EMR system, a Patient Diary and Practice Management platform.
                    <span *ngIf="selectedSubscriptionTier === 'standard'">
                        Your ZAR 3,000 monthly subscription (exclusive of VAT) is inclusive of monthly ZAR 200.00 worth
                        of AI tokens and 20 text message credits. These tokens never expire. Additional usage is charged
                        on a pay-as-you-go basis.
                    </span>
                    <span *ngIf="selectedSubscriptionTier === 'premium'">
                        Your ZAR 6,000 monthly Premium subscription (exclusive of VAT) includes unlimited AI tokens and
                        unlimited text message credits. Usage is tracked but not charged.
                    </span>
                    Your first payment includes a once-off ZAR 5,000.00 onboarding fee (exclusive of VAT). It is
                    mandatory and covers virtual onboarding and training, so that you are set up to get the maximum
                    benefit from MedicAI. We do not charge for training additional team members later.
                    Your subscription will automatically renew each month on your initial payment date. You can cancel
                    your
                    subscription at any time from within the MedicAI platform. By proceeding, you agree to the <a
                        href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
                    and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                        policy</a>.
                </div>
            </ng-container>


        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" *ngIf="!isNewSubscription && !isPremium">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    TOKEN USAGE
                </mat-panel-title>
            </mat-expansion-panel-header>

            <app-token-usage></app-token-usage>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="false" *ngIf="!isNewSubscription && !isPremium && !stateUnit">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    TEXT MESSAGE USAGE
                </mat-panel-title>
            </mat-expansion-panel-header>

            <app-text-message-usage></app-text-message-usage>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="false" *ngIf="connectFeatureEnabled && !isNewSubscription && !stateUnit">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    MEDICAI CONNECT
                </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
                <app-connect-panel [group]="group" [subscription]="subscription"
                    (enable)="startConnectEnable()"></app-connect-panel>
            </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" *ngIf="!isNewSubscription" (opened)="loadInvoices()">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    INVOICES
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-list *ngIf="invoices?.length">
                <mat-list-item *ngFor="let invoice of invoices" class="auto-height">
                    <div class="invoice-item">
                        <div class="invoice-details">
                            <p><strong>{{ invoice.createdAt | date: 'dd/MM/yyyy' }}</strong> {{invoice.fileName}}</p>
                            <!-- <span class="invoice-date">{{ invoice.createdAt | date: 'dd/MM/yyyy' }}</span>
                                <span class="invoice-name">{{invoice.fileName}}</span> -->
                        </div>
                        <div class="actions">
                            <a [href]="invoice.fileUrl" target="_blank"><mat-icon>download</mat-icon></a>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </mat-list-item>
            </mat-list>
            <div *ngIf="!invoices && invoicesLoaded" class="hint text-center p-t-20">
                No invoices available.
            </div>
            <div *ngIf="!invoices && !invoicesLoaded" class="hint text-center p-t-20">
                Loading invoices...
            </div>

        </mat-expansion-panel>

    </mat-accordion>
    <div class="mobile-spacer"></div>
</div>



<ng-template #manageSubscriptionDialog>
    <h1 mat-dialog-title>Manage Subscription</h1>
    <div mat-dialog-content>

        <p class="hint">
            NOTE: You can update the details that appear on your invoice by pressing the button below. This will allow
            you to set the name, address, VAT number (if applicable), and optional billing email addresses for MedicAI
            invoices and billing alerts.
        </p>
        <div class="flex-center">
            <button mat-raised-button color="primary" (click)="openInvoiceDetailsDialog()">
                Update Invoice Details
            </button>
        </div>

        <p class="hint m-t-10" *ngIf="cardOnFileLabel">
            <strong>Card on file:</strong> {{ cardOnFileLabel }}
        </p>
        <p class="hint m-t-10">
            NOTE: You can update the card details linked to your subscription by pressing the button below. A secure
            payment popup will open. A small ZAR 5 charge is processed to validate the new card.
        </p>
        <div class="flex-center">
            <button mat-raised-button color="primary" (click)="updateCardDetails()" [disabled]="processingSubscription">
                Update Card Details
            </button>
        </div>

        <p class="hint m-t-10">
            NOTE: If you cancel your subscription you will lose access to MedicAI features for this patient list until
            you resubscribe.
        </p>
        <div class="flex-center">
            <button mat-raised-button color="warn" (click)="cancelSubscription()">
                Cancel Subscription
            </button>
        </div>

        <p class="hint m-t-10">
            By proceeding with any of the above actions, you agree to the <a
                href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
            and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                policy</a>.
        </p>

    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Close</button>
    </div>
</ng-template>


<ng-template #invoiceDetailsDialog>
    <h1 mat-dialog-title>Invoice Details</h1>
    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <p class="hint">
                    NOTE: The name, address, and VAT number below will appear on MedicAI invoices. Optional billing
                    emails receive copies of invoices and billing alerts (the account owner always receives them too).
                </p>
                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>Name/Company Name</mat-label>
                    <input matInput [(ngModel)]="invoiceDetails.invoiceName" type="text" required>
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Address</mat-label>
                    <input matInput [(ngModel)]="invoiceDetails.invoiceAddress" type="text">
                    <!--  <textarea matInput [(ngModel)]="invoiceDetails.invoiceAddress" rows="4"></textarea> -->
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>VAT Number</mat-label>
                    <input matInput [(ngModel)]="invoiceDetails.taxNumber" type="text">
                </mat-form-field>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Billing / invoice email (optional)</mat-label>
                    <input matInput [(ngModel)]="invoiceDetails.invoiceEmail" type="text"
                        placeholder="accounts@practice.co.za, billing@practice.co.za">
                    <mat-hint>Comma-separated extra addresses for invoices and billing alerts (the account owner is
                        always included).</mat-hint>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width m-t-45" *ngIf="shouldShowPromoCode">
                    <mat-label>Promo Code (Optional)</mat-label>
                    <input matInput [(ngModel)]="promoCode" type="text" placeholder="Enter promo code"
                        [disabled]="validatingPromoCode" (blur)="validatePromoCode()" (input)="onPromoCodeInput()">
                    <mat-spinner *ngIf="validatingPromoCode" matSuffix diameter="20"
                        style="margin-right: 8px;"></mat-spinner>
                    <mat-hint *ngIf="promoCodeDetails && !validatingPromoCode">
                        <span style="color: green;">✓ Promo code applied:
                            <span *ngIf="promoCodeDetails.discountType === 'percentage'">
                                {{promoCodeDetails.discountAmount}}% discount
                            </span>
                            <span *ngIf="promoCodeDetails.discountType === 'fixed'">
                                ZAR {{promoCodeDetails.discountAmount}} discount
                            </span>
                            <span *ngIf="promoCodeDetails.trialExtensionDays">
                                + {{promoCodeDetails.trialExtensionDays}} days trial extension
                            </span>
                        </span>
                    </mat-hint>
                    <mat-error
                        *ngIf="promoCode && !promoCodeDetails && !validatingPromoCode && promoCode.trim().length > 0">
                        Invalid promo code
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" (click)="saveInvoiceDetails()"
            [disabled]="!invoiceDetails.invoiceName || validatingPromoCode || promoCodeError">Save</button>
    </div>
</ng-template>

<ng-template #tokenPurchaseDialog>
    <h1 mat-dialog-title>Purchase Tokens</h1>
    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <p class="hint">
                    NOTE: We will attempt to charge the payment details linked to your subscription to complete the
                    token purchase. You can update the card details linked to your subscription by clicking "Manage
                    Subscription" on the subscription status block. By proceeding, you agree to the <a
                        href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
                    and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                        policy</a>.
                </p>
                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>Purchase Amount (ZAR)</mat-label>
                    <input matInput [(ngModel)]="tokenPurchase.amount" type="number" min="5" required>
                    <span matPrefix class="p-l-10"> R </span>
                    <mat-hint class="hint">Min: ZAR 100.00 (excl. VAT). VAT (15%) will be added at checkout.</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="tokenPurchase"
            [disabled]="tokenPurchase.amount < 5">Purchase</button>
    </div>
</ng-template>


<ng-template #textMessageCreditPurchaseDialog>
    <h1 mat-dialog-title>Purchase Text Message Credits</h1>
    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <p class="hint">
                    NOTE: We will attempt to charge the payment details linked to your subscription to complete the
                    text message credit purchase. You can update the card details linked to your subscription by
                    clicking "Manage Subscription" on the subscription status block. By proceeding, you agree to the <a
                        href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
                    and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                        policy</a>.
                </p>
                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>Number of Credits</mat-label>
                    <input matInput [(ngModel)]="textMessageCreditPurchase.amount" type="number" min="10" required>
                    <span matSuffix class="p-r-10"> credits </span>
                    <mat-hint class="hint">1 Credit = ZAR 3.00 (excl. VAT). Minimum 10 credits required. VAT (15%) will
                        be added at checkout.</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="textMessageCreditPurchase"
            [disabled]="textMessageCreditPurchase.amount < 10">Purchase</button>
    </div>
</ng-template>


<ng-template #autoRechargeDialog>
    <h1 mat-dialog-title>Token Auto Recharge Settings</h1>
    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <p class="hint">
                    NOTE: You can enable auto recharge to ensure you never run out of tokens. Set a threshold and an
                    amount for auto recharge. When your token balance reaches the threshold, the system will
                    automatically recharge your tokens with the amount you specified using the card details linked to
                    your subscription. You can update the card details linked to your subscription by clicking "Manage
                    Subscription" on the subscription status block. By proceeding, you agree to the <a
                        href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
                    and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                        policy</a>.
                </p>

                <div class="m-b-10 m-t-10">
                    <mat-slide-toggle [(ngModel)]="autoRecharge.enabled" color="primary">Enable Auto
                        Recharge</mat-slide-toggle>
                </div>

                <ng-container *ngIf="autoRecharge.enabled">
                    <mat-form-field appearance="outline" class="full-width m-t-10">
                        <mat-label>Auto Recharge Threshold (ZAR)</mat-label>
                        <input matInput [(ngModel)]="autoRecharge.threshold" type="number" min="100" required>
                        <span matPrefix class="p-l-10"> R </span>
                        <mat-hint class="hint">Min: ZAR 100.00 (excl. VAT)</mat-hint>
                    </mat-form-field>


                    <mat-form-field appearance="outline" class="full-width m-t-10">
                        <mat-label>Auto Recharge Amount (ZAR)</mat-label>
                        <input matInput [(ngModel)]="autoRecharge.amount" type="number" min="500" required>
                        <span matPrefix class="p-l-10"> R </span>
                        <mat-hint class="hint">Min: ZAR 500.00 (excl. VAT). VAT (15%) will be added when
                            charging.</mat-hint>
                    </mat-form-field>

                </ng-container>

            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="autoRecharge"
            [disabled]="autoRecharge.enabled ? (autoRecharge.amount < 500 || autoRecharge.threshold < 100) : false">Save</button>
    </div>
</ng-template>

<ng-template #textMessageAutoRechargeDialog>
    <h1 mat-dialog-title>Text Message Auto Recharge Settings</h1>
    <div mat-dialog-content>
        <div class="form-container">
            <div class="form-section">
                <p class="hint">
                    NOTE: You can enable auto recharge to ensure you never run out of text message credits. Set a
                    threshold and an
                    amount for auto recharge. When your credit balance reaches the threshold, the system will
                    automatically recharge your text message credits with the amount of credits you specified using the
                    card details linked to
                    your subscription. You can update the card details linked to your subscription by clicking "Manage
                    Subscription" on the subscription status block. By proceeding, you agree to the <a
                        href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">terms of service</a>
                    and <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">privacy
                        policy</a>.
                </p>

                <div class="m-b-10 m-t-10">
                    <mat-slide-toggle [(ngModel)]="textMessageAutoRecharge.enabled" color="primary">Enable Auto
                        Recharge</mat-slide-toggle>
                </div>

                <ng-container *ngIf="textMessageAutoRecharge.enabled">
                    <mat-form-field appearance="outline" class="full-width m-t-10">
                        <mat-label>Auto Recharge Threshold (Credits)</mat-label>
                        <input matInput [(ngModel)]="textMessageAutoRecharge.threshold" type="number" min="10" required>
                        <span matSuffix class="p-r-10"> credits </span>
                        <mat-hint class="hint">Min: 10 credits</mat-hint>
                    </mat-form-field>


                    <mat-form-field appearance="outline" class="full-width m-t-10">
                        <mat-label>Auto Recharge Amount (Credits)</mat-label>
                        <input matInput [(ngModel)]="textMessageAutoRecharge.amount" type="number" min="100" required>
                        <span matSuffix class="p-r-10"> credits </span>
                        <mat-hint class="hint">1 Credit = ZAR 3.00 (excl. VAT). Minimum 100 credits required. VAT (15%)
                            will be added when charging.</mat-hint>
                    </mat-form-field>

                </ng-container>

            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button [mat-dialog-close]="">Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="textMessageAutoRecharge"
            [disabled]="textMessageAutoRecharge.enabled ? (textMessageAutoRecharge.amount < 100 || textMessageAutoRecharge.threshold < 10) : false">Save</button>
    </div>
</ng-template>

<ng-template #onboardingDialog>
    <h1 mat-dialog-title>Welcome to MedicAI!</h1>
    <div mat-dialog-content class="onboarding-dialog-content">
        <div class="welcome-intro">
            <p>Thank you for subscribing! We're excited to have you on board.</p>
            <p>Your account is now active. To get started, please complete these two essential steps:</p>
        </div>

        <div class="onboarding-step">
            <div class="step-header">
                <span class="step-number">1</span>
                <h3>Request Support & Send Branding</h3>
            </div>
            <p class="step-description">
                Add MedicAI to your support team and send us your practice letterhead and footer for branding.
            </p>
            <div class="step-tip">
                <mat-icon>info_outline</mat-icon>
                <span>Watch this <a href="https://drive.google.com/file/d/1SuVC_Y8KWMpRxJ7S1BQPghKeGDOPloCE/view"
                        target="_blank">1-minute video</a> to see how</span>
            </div>
            <div class="step-action">
                <button mat-raised-button color="primary" class="action-button"
                    [disabled]="supportRequested || requestingSupport" (click)="requestSupport()">
                    <mat-icon *ngIf="supportRequested" class="button-icon">check_circle</mat-icon>
                    <span *ngIf="requestingSupport">Requesting...</span>
                    <span *ngIf="!requestingSupport && !supportRequested">Request Support</span>
                    <span *ngIf="supportRequested">Support Requested</span>
                </button>
                <button mat-raised-button class="whatsapp-support-btn action-button m-l-10"
                    (click)="openWhatsAppSupport()" [disabled]="!user || !group || openingWhatsAppSupport">
                    <mat-icon svgIcon="whatsapp"></mat-icon> WhatsApp Support
                </button>
            </div>
            <div *ngIf="supportRequested" class="step-success">
                <mat-icon>check_circle</mat-icon>
                <span>Support request submitted! Our team will be in touch soon.</span>
            </div>
            <p class="step-note">
                After requesting support, email your practice letterhead and footer (PDF) to
                <a href="mailto:info@medicai.co.za">info@medicai.co.za</a> for branding.
            </p>
        </div>

        <div class="onboarding-step">
            <div class="step-header">
                <span class="step-number">2</span>
                <h3>Book Your Onboarding Session</h3>
            </div>
            <p class="step-description">
                Schedule your structured onboarding and training session. We'll help you:
            </p>
            <ul class="step-list">
                <li>Configure MedicAI for your practice</li>
                <li>Align workflows with your processes</li>
                <li>Train your team on key features</li>
                <li>Get you up and running quickly</li>
            </ul>
            <div class="step-action">
                <a mat-raised-button color="primary" class="action-button"
                    href="https://calendly.com/demo-medicai/medicai-onboarding-training" target="_blank">
                    Book Onboarding & Training Session
                </a>
            </div>
            <p class="step-note">
                <strong>Note:</strong> The onboarding and training fee (R5,000 excl. VAT) will be included in your first
                billing cycle.
            </p>
        </div>

        <div class="dialog-footer-note">
            <p>Questions? Contact us at <a href="mailto:contact@medicai.co.za">contact@medicai.co.za</a></p>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Got it, thanks!</button>
    </div>
</ng-template>

<ng-template #connectEnableDialog>
    <h1 mat-dialog-title>Enable MedicAI Connect</h1>
    <div mat-dialog-content>
        <p class="hint">
            Select which group members should receive access to Connect and choose the role each should have on
            Connect. The group owner always receives access as Tenant Admin.
        </p>
        <div *ngIf="connectEnableLoading" class="flex-center p-t-20">
            <mat-spinner diameter="32"></mat-spinner>
        </div>
        <div *ngIf="!connectEnableLoading && connectEnableUserList.length" class="connect-user-list">
            <div *ngFor="let user of connectEnableUserList" class="connect-user-row">
                <mat-checkbox [checked]="isConnectEnableSelected(user.userId)"
                    [disabled]="isConnectEnableOwner(user.userId)" (change)="toggleConnectEnableUser(user.userId)">
                </mat-checkbox>
                <span class="connect-user-name">{{ user.title }} {{ user.name }} {{ user.surname }}</span>
                <span *ngIf="isConnectEnableOwner(user.userId)" class="connect-owner-badge">Owner</span>
                <mat-form-field appearance="outline" class="connect-role-field">
                    <mat-label>Connect role</mat-label>
                    <mat-select [ngModel]="connectUserRoles[user.userId]"
                        (ngModelChange)="connectUserRoles[user.userId] = $event"
                        [disabled]="isConnectEnableOwner(user.userId) || !isConnectEnableSelected(user.userId)">
                        <mat-option *ngFor="let option of connectRoleOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <p *ngIf="!connectEnableLoading && connectEnableUserList.length === 0" class="hint">No group members found.</p>

        <div class="connect-share-subscription-section p-t-16">
            <mat-slide-toggle [(ngModel)]="connectShareSubscription" color="primary">Share my subscription with
                Connect</mat-slide-toggle>
            <p class="hint connect-share-note">
                If you share your subscription with Connect, Connect claim costs will be billed to the card details
                linked to your current subscription on your preferred day each month.
                If you prefer to keep billing separate or have a bureau that should carry those costs, do not share.
            </p>
            <div *ngIf="connectShareSubscription" class="connect-billing-day p-t-12">
                <mat-form-field appearance="outline" class="connect-field">
                    <mat-label>Preferred billing day of month</mat-label>
                    <input matInput type="number" min="1" max="28" step="1" [(ngModel)]="connectBillingDayOfMonth" />
                    <mat-hint class="hint">Pick a day between 1 and 28.</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary"
            [disabled]="connectEnableSubmitting || connectEnableLoading || connectEnableUserList.length === 0 || (connectShareSubscription && (connectBillingDayOfMonth < 1 || connectBillingDayOfMonth > 28))"
            (click)="confirmConnectEnable()">
            <mat-spinner *ngIf="connectEnableSubmitting" diameter="20" class="button-spinner"></mat-spinner>
            {{ connectEnableSubmitting ? 'Enabling...' : 'Enable Connect' }}
        </button>
    </div>
</ng-template>


<!-- <div class="settings-container">
    <div class="settings-header">
        <h2>Subscription & Token Settings</h2>
        <p>Manage your MedicAI subscription and tokens</p>
    </div>
    <div class="settings-content">
        <div class="subscription-management">
            <div class="card">
                <h3>MedicAI Subscription</h3>
                <div class="subscription-details">
                    <p>Our MedicAI subscription includes:</p>
                    <ul>
                        <li>Benefit 1</li>
                        <li>Benefit 2</li>
                        <li>Benefit 3</li>
                    </ul>
                    <p class="subscription-price">Monthly Price: ZAR 1,500.00</p>
                </div>
                <div class="subscription-form">
                    <form [formGroup]="subscriptionForm" (ngSubmit)="onSubmit()" [hidden]="processingSubscription">
                        <div class="form-actions">
                            <button mat-raised-button color="primary" type="submit">Purchase Subscription</button>
                        </div>
                    </form>
                    <div [hidden]="!processingSubscription" class="processing-subscription">
                        <ng-container *ngIf="!paymentFrameLoaded">
                            <mat-spinner></mat-spinner>
                            <p>Processing your subscription payment</p>
                        </ng-container>
                        <iframe #paymentFrame name="paymentFrame" id="paymentFrame" class="payment-frame">
                            <p>Your browser does not support iframes. We were unable to process your payment.</p>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="token-management">
            <div class="card">
                <h3>Token Management</h3>
                <div class="token-balance">
                    <p>Current Token Balance: <span>{{ tokenBalance }}</span></p>
                </div>
                <div class="purchase-tokens">
                    <h4>Purchase Tokens</h4>
                    <form [formGroup]="purchaseTokensForm" (ngSubmit)="onPurchaseTokens()">
                        <mat-form-field appearance="outline">
                            <mat-label>Number of Tokens</mat-label>
                            <input matInput type="number" formControlName="numTokens" required>
                        </mat-form-field>
                        <button mat-raised-button color="primary" type="submit">Purchase Tokens</button>
                    </form>
                </div>
                <div class="auto-recharge">
                    <h4>Auto Recharge Settings</h4>
                    <form [formGroup]="autoRechargeForm" (ngSubmit)="onSaveAutoRecharge()">
                        <mat-form-field appearance="outline">
                            <mat-label>Auto Recharge Amount</mat-label>
                            <input matInput type="number" formControlName="rechargeAmount" required>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Auto Recharge Threshold</mat-label>
                            <input matInput type="number" formControlName="rechargeThreshold" required>
                        </mat-form-field>
                        <button mat-raised-button color="primary" type="submit">Save Auto Recharge Settings</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> -->